export const BuildInfo = {timestamp:1778541773000}
